import {useMemo} from 'react'
import {useAuth} from 'src/contexts/AuthContext'
import {useNavigationMenu} from 'src/layouts/main-layout/app-sidebar/navigation/hooks/use-navigation-menu.hook'
import {NavigationMenuType} from 'src/layouts/main-layout/app-sidebar/navigation/types/navigation-menu.type'
import {applyNavigationMenuVisibility} from 'src/layouts/main-layout/app-sidebar/navigation/utils/apply-navigation-menu-visibility'
import {navigationMenuVisibilityRules} from 'src/layouts/main-layout/app-sidebar/navigation/utils/navigation-menu-visibility-rules'
import {MIGRATED_PORTAL_MODULES, type MigratedPortalModule} from 'src/lib/portal-migration/migrated-portal-modules'

function collectNavigationRoutes(items: NavigationMenuType[] | undefined, routes = new Set<string>()): Set<string> {
  if (!items) return routes

  for (const item of items) {
    routes.add(item.route)
    collectNavigationRoutes(item.children, routes)
  }

  return routes
}

function resolveUserPermissions(userPermissions: string[] | undefined, tokenPermissions: string[] | undefined): string[] {
  if (userPermissions?.length) return userPermissions
  return tokenPermissions ?? []
}

export function useVisiblePortalModules(): {
  visibleModules: MigratedPortalModule[]
  isLoading: boolean
  refreshVisibleModules: () => Promise<unknown>
} {
  const {user, userToken, userIsB2c} = useAuth()
  const {data: menuFromApi, isLoading, refetch} = useNavigationMenu()

  const userPermissions = resolveUserPermissions(user?.permissions, userToken?.userPermissions)

  const visibleModules = useMemo(() => {
    const menu = menuFromApi
      ? applyNavigationMenuVisibility(menuFromApi, userPermissions, navigationMenuVisibilityRules, {
          userIsB2c,
        })
      : undefined

    const navigationRoutes = collectNavigationRoutes(menu)

    return MIGRATED_PORTAL_MODULES.filter(
      (portalModule) => Boolean(portalModule.label) && (navigationRoutes.has(portalModule.legacyPath) || navigationRoutes.has(portalModule.newPath)),
    )
  }, [menuFromApi, userPermissions, userIsB2c])

  return {visibleModules, isLoading, refreshVisibleModules: refetch}
}
